import React from 'react';
import { DialogTitle, Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { getPolicyIcon } from './utils';

/**
 * PolicyDialogHeader Component
 *
 * Displays the dialog header with policy name, icon, and close button.
 *
 * @param {Object} props
 * @param {Object} props.policy - Policy object
 * @param {Function} props.onClose - Callback to close dialog
 */
function PolicyDialogHeader({ policy, onClose }) {
  return (
    <DialogTitle>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          {getPolicyIcon(policy.name)}
          <Typography variant="h6" sx={{ ml: 1 }}>
            {policy.name.replace('-policy', '').toUpperCase()} Policy Details
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
  );
}

export default PolicyDialogHeader;
